import { render, staticRenderFns } from "./ImageCanvas.vue?vue&type=template&id=30dad315&scoped=true&"
import script from "./ImageCanvas.vue?vue&type=script&lang=js&"
export * from "./ImageCanvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30dad315",
  null
  
)

export default component.exports